import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { Divider, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import GroupIcon from '@mui/icons-material/Group';
import CustomTableSelectAgentes from '../CustomTableSelectAgentes/CustomTableSelectAgentes';
import { Agente } from '../../dto/Agentes';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '6px',
};

export default function CustomModalSelectAgentes(props: {
    data: Agente[],
    buscouAgentes: boolean;
    openModal: boolean,
    isSearch: boolean,
    podeEditar: boolean,
    handleFunction: () => void,
    handleSetAgentePedido: (agente: Agente) => void,
    handleEditAgente: (agente: Agente) => void
}) {
    const [open, setOpen] = React.useState(props.openModal);
    const [searchValue, setSearchValue] = React.useState('');
    const [filteredData, setFilteredData] = React.useState<Agente[]>([]);

    const handleOpen = () => {
        setOpen(true);
        props.handleFunction();
    };

    const handleClose = () => {
        setSearchValue("");
        setOpen(false);
    }

    const handleSetAgente = (agente: Agente) => {
        props.handleSetAgentePedido(agente);
        handleClose();
    };

    const handleEditarAgente = (agente: Agente) => {
        props.handleEditAgente(agente);
        handleClose();
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchValue(value);

        const filtered = props.data.filter((agente) =>
            Object.values(agente).some((val) =>
                val?.toString().toLowerCase().includes(value)
            )
        );
        setFilteredData(filtered);
    };

    React.useEffect(() => {
        if (open) {
            setFilteredData(props.data);
        }
    }, [open, props.data]);

    const inputRef = React.useRef<HTMLInputElement | null>(null);
    
        React.useEffect(() => {
            if (open) {
                // pequeno delay para garantir que o conteúdo já foi montado
                setTimeout(() => {
                    inputRef.current?.focus();
                }, 0);
            }
        }, [open]);

    return (
        <div>
            {!props.isSearch && (
                <Button
                    className="fields"
                    variant="contained"
                    onClick={handleOpen}
                    sx={{ maxWidth: 200, backgroundColor: '#5693B9', color: '#fff', fontWeight: 'bold' }}
                >
                    Adicionar item
                </Button>
            )}
            {props.isSearch && (
                <IconButton
                    aria-label="search"
                    onClick={handleOpen}
                    disabled={!props.podeEditar}
                    sx={{ color: '#0965c1' }}
                >
                    {props.podeEditar ? <SearchIcon /> : <SearchOffIcon />}
                </IconButton>
            )}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        ...style,
                        position: 'relative',
                        p: 3,
                        height: '70vh',
                        width: '60%',
                        maxWidth: '1100px',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 0,                            
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <GroupIcon sx={{ fontSize: 20, color: '#0965c1' }} />
                            <Typography id="modal-modal-title" marginBottom={-0.3} variant="subtitle1" align='center' component="h2" fontSize='15px' color='#334155'>
                            Buscar Agente
                        </Typography>
                        </Box>
                        
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                color: '#5693B9',
                                '&:hover': {
                                    color: 'gray',
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />
                    <TextField
                        fullWidth
                        label=""
                        variant="outlined"
                        value={searchValue}
                        onChange={handleSearchChange}
                        autoFocus
                        inputRef={inputRef}
                        size="small"
                        sx={{ marginBottom: 2 }}
                    />
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                        <CustomTableSelectAgentes
                            data={filteredData}
                            buscouAgentes={props.buscouAgentes}
                            handleSetAgente={handleSetAgente}
                            isAgente={false}
                            handleEditarAgente={handleEditarAgente}
                        />
                    </Box>
                </Box>
            </Modal>
        </div>
    );
}
